<template>
    <OptionAbstract :compact="compact">

        <div v-if="beta" class="option-beta">beta</div>

        <div class="option-image">
            <ViewerImageRaw :data="data" />
        </div>

        <div class="option-label" :class="{'option-compact': compact}" v-html="label">
        </div>

    </OptionAbstract>
</template>

<script>
import ViewerImageRaw from '@/components/common/viewer/ViewerImageRaw.vue'
import OptionAbstract from '@/components/flow/options/OptionAbstract.vue'

export default {
    name: 'OptionImage',
    components: {
        OptionAbstract,
        ViewerImageRaw
    },
    props: {
        data: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        beta: {
            type: Boolean,
            default: false
        },
        compact: {
            type: Boolean,
            default: false
        },
    }
}
</script>

<style>
.option-abstract-disabled .option-image img {
    filter: blur(10px) brightness(0.5);
}
</style>

<style scoped>
.option-beta {
    position: absolute;
    display: block;
    top: 10px;
    right: 10px;
    color: rgb(var(--v-theme-white));
    background-color: rgb(var(--v-theme-warning));
    padding-left: 10px;
    padding-right: 10px;
    font-size: 1.1rem;
    font-weight: bold;
    border-radius: 10px;
    z-index: 1;
}

.option-image {
    position: relative;
    aspect-ratio: 1 / 1;
    height: 100%;
    width:auto;
    margin-top: 20px;
    margin-bottom: 10px;
}

.option-label {
    font-size: 3rem;
    text-transform: capitalize;
    margin-bottom: 20px;
}

.option-label.option-compact {
    font-size: 2.4rem;
}

@media (max-width: 3000px) {
    .option-label {
        font-size: 2.5rem;
    }

    .option-label.option-compact {
        font-size: 1.9rem;
    }
}

@media (max-width: 2000px) {
    .option-label {
        font-size: 2.0rem;
    }

    .option-label.option-compact {
        font-size: 1.4rem;
    }
}

@media (max-width: 1600px) {
    .option-label {
        font-size: 1.8rem;
    }

    .option-label.option-compact {
        font-size: 1.3rem;
    }
}

@media (max-width: 1200px) {
    .option-label {
        font-size: 1.6rem;
    }

    .option-label.option-compact {
        font-size: 1.1rem;
    }
}

@media (max-width: 800px) {
    .option-label {
        font-size: 1.8rem;
    }

    .option-label.option-compact {
        font-size: 1.3rem;
    }
}

@media (max-width: 600px) {
    .option-label {
        font-size: 1.3rem;
    }

    .option-label.option-compact {
        font-size: 0.9rem;
    }
}

@media (max-width: 400px) {
    .option-label {
        font-size: 1.2rem;
    }

    .option-label.option-compact {
        font-size: 0.8rem;
    }
}
</style>